<template>
<page no-styling>
  <div class="card black_background pb1">
    <card-header
      :title="$t('cms.support.Title')"
      :description="$t('cms.support.Description')"
      style="margin-bottom: 0"
    >
      <template #icon>
        <icon support xlarge />
      </template>
    </card-header>
    <support-item
      v-for="(data ,index) in supportTopics"
      :key="data.id"
      :title="data.title"
      :description="data.description"
      :hasContact="data.hasContact"
      :isLast="index === supportTopics.length - 1"
    >
      <div class="dot-line">
        <p v-for="answer in data.answers" :key="answer.id">
          <strong>{{answer.title}}. </strong> {{answer.description}}
        </p>
      </div>
    </support-item>
  </div>
</page>
</template>

<script>
import CardHeader from '@/components/global/CardHeader.vue';
import Icon from '@/components/global/Icon.vue';
import SupportItem from '@/components/SupportItem.vue';
import vueI18n from '@/plugins/i18n';

export default {
  components: { CardHeader, Icon, SupportItem },
  methods: {
    generateAnswers(name) {
      const answers = [];
      for (let n = 1; n < 11; n += 1) {
        if (vueI18n.te(`cms.support.${name}.Answer${n}.Title`) && vueI18n.te(`cms.support.${name}.Answer${n}.Description`)) {
          answers.push({
            title: this.$t(`cms.support.${name}.Answer${n}.Title`),
            description: this.$t(`cms.support.${name}.Answer${n}.Description`),
          });
        }
      }
      return answers;
    },
  },

  data() {
    return {
      supportTopics: [
        {
          id: 1,
          title: this.$t('cms.support.activate_account.Title'),
          description: this.$t('cms.support.activate_account.Description'),
          hasContact: true,
        },
        {
          id: 2,
          title: this.$t('cms.support.upgrade_beacon.Title'),
          description: this.$t('cms.support.upgrade_beacon.Description'),
          hasContact: true,
        },
        {
          id: 3,
          title: this.$t('cms.support.general_question.Title'),
          description: this.$t('cms.support.general_question.Description'),
          hasContact: true,
        },
        {
          id: 4,
          title: this.$t('cms.support.feedback.Title'),
          description: this.$t('cms.support.feedback.Description'),
          hasContact: true,
        },
        {
          id: 5,
          title: this.$t('cms.support.why_important.Title'),
          answers: this.generateAnswers('why_important'),
          hasContact: false,
        },
        {
          id: 6,
          title: this.$t('cms.support.what_beacon.Title'),
          answers: this.generateAnswers('what_beacon'),
          hasContact: false,
        },
        {
          id: 7,
          title: this.$t('cms.support.what_can_beacons_do.Title'),
          answers: this.generateAnswers('what_can_beacons_do'),
          hasContact: false,
        },
      ],
    };
  },
};

</script>

<style lang="scss" scoped>
.dot-line {
  p {
    line-height: 20px;
    padding: 20px 0;
    border-bottom: 1px dashed rgba(0, 0, 0, .3);
  }
  p:last-child {
    border-bottom: none;
  }
}
</style>
